import React, { useState, useContext, FunctionComponent } from 'react';
import { equals } from 'ramda';

import { formatDate } from 'helpers/date';

import { presetDateRanges } from './DatePicker.helpers';

type Props = { children: React.ReactNode };

type DateRange = {
  from: Date;
  to: Date;
};

export type DatePickerState = DateRange & {
  setDateRange: React.Dispatch<React.SetStateAction<DateRange>>;
  startDate: string;
  endDate: string;
  defaultDateRange: boolean;
};

type State = [DateRange, React.Dispatch<React.SetStateAction<DateRange>>];

export const DatePickerContext = React.createContext<State>([
  presetDateRanges.pastNineDays,
  () => {},
]);

export const DatePickerProvider: FunctionComponent<Props> = (props) => {
  const [dateRange, setDateRange] = useState<DateRange>(
    presetDateRanges.pastNineDays,
  );

  const value = React.useMemo(() => [dateRange, setDateRange], [dateRange]);

  return <DatePickerContext.Provider value={value as State} {...props} />;
};

export const useDatePicker = (): DatePickerState => {
  const [dateRange, setDateRange] = useContext<State>(DatePickerContext);
  const { from, to } = dateRange;

  return {
    ...dateRange,
    setDateRange,
    startDate: formatDate(from),
    endDate: formatDate(to),
    defaultDateRange: equals(dateRange, presetDateRanges.pastNineDays),
  };
};
